import { Component, Event, EventEmitter, Host, Prop, h } from '@stencil/core';
import { If } from '@utils/If';

@Component({
  tag: 'custom-button',
  styleUrl: 'custom-button.scss',
  shadow: true
})
export class CustomButton {
  @Prop() variant: 'primary' | 'outlined' = 'primary';
  @Prop() disabled: boolean = false;
  @Prop() type: 'submit' | 'reset' | 'button' = 'button';
  @Prop() isLoading: boolean = false;
  @Event() buttonClick: EventEmitter<void>;

  private handleClick = () => {
    this.buttonClick.emit();
  };

  render() {
    return (
      <Host>
        <button
          type={this.type}
          disabled={this.disabled}
          onClick={this.handleClick}
          class={`min-w-20 rounded-xl w-full flex items-center justify-center gap-2  disabled:cursor-default font-semibold cursor-pointer border border-solid px-3 py-2.5  text-sm ${this.variant === 'primary' ? 'bg-sb-primary border-sb-primary disabled:bg-sb-primary-200 text-white disabled:border-sb-primary-200' : 'bg-white text-sb-primary border-sb-primary disabled:bg-white disabled:text-gray-400 disabled:border-gray-400'
            }`}
        >
          <If condition={this.isLoading} children={<span class="spinner" />} />
          <slot />
        </button>
      </Host>
    );
  }
}
